





















import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";

@Component
export default class BasePanel extends Vue {
	@Prop({ type: String, default: "" }) title!: string;
	@Prop({ type: [Number, String], default: 20 }) top!: number | string;

	get border() {
		return this.$attrs.hasOwnProperty("border") ? "border" : "";
	}
	get hasHeaderSlot() {
		return this.$slots.header;
	}
	get hasSuffixSlot() {
		return this.$slots.suffix;
	}
	get marginTop() {
		return String(this.top).replace(/(px|%)/g, "") + "px";
	}
}
